import { Component, OnInit } from "@angular/core";
import {
  PostPreviewTnc,
  WebsiteConfigurationService
} from "../website-configuration/website-configuration.service";

@Component({
  selector: "app-preview-tnc",
  templateUrl: "./preview-tnc.component.html",
  styleUrls: ["./preview-tnc.component.scss"]
})
export class PreviewTncComponent implements OnInit {
  previewData: PostPreviewTnc | null = null;

  relatedArticles = [
    {
      slug: "ai-in-insurance",
      title: "How AI Is Shaping Insurance",
      date: new Date("2024-11-01"),
      coverImg: "https://via.placeholder.com/180x120"
    },
    {
      slug: "blockchain-claims",
      title: "Blockchain in Claims Processing",
      date: new Date("2024-10-15"),
      coverImg: "https://via.placeholder.com/180x120"
    },
    {
      slug: "data-security-trends",
      title: "Trends in Data Security",
      date: new Date("2024-09-20"),
      coverImg: "https://via.placeholder.com/180x120"
    }
  ];

  constructor(private previewService: WebsiteConfigurationService) {}

  ngOnInit(): void {
    // fetch the full TNC preview object
    this.previewData = this.previewService.getPreviewTncData();
  }

  // convenience getter for template
  get tncList() {
    return this.previewData?.tncList || [];
  }

  get lastUpdatedBy() {
    return this.previewData?.lastUpdatedBy || null;
  }
}
